export const APP_INTEGRATIONS = 'APP_INTEGRATIONS';
export const ADMINS = 'ADMINS';
export const HUBS = 'HUBS';
export const DETAILS_MORE_APPS_FETCH = 'DETAILS_MORE_APPS_FETCH';